module.exports = __webpack_public_path__ + "static/tw_bottom_slice-54fbfafb785878febd5c99e6369ad511.svg";